import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  @Input() text: string = 'Tooltip text'; // Tooltip message
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top'; // Positioning
}
